import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'amfe-flexible'
import './assets/styles/index.scss'
// eslint-disable-next-line import/order
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
